import type { UserOrganizationInvitationResource } from '@clerk/types';
import { V2 } from '@firmable/common';
import { Logo } from '@firmable/icons';
import React from 'react';
import { CreateCompanyFooter, OrgAvatar } from '../shared';

export interface InvitationCardProps {
  invitation: UserOrganizationInvitationResource;
  onAccept: (invitation: UserOrganizationInvitationResource) => Promise<void>;
  onError?: () => void;
  onCreateCompany?: () => void;
}

export const InvitationCard = ({ invitation, onAccept, onError, onCreateCompany }: InvitationCardProps) => {
  const [isJoining, setIsJoining] = React.useState(false);

  const orgName = invitation.publicOrganizationData.name;

  const handleJoin = async () => {
    setIsJoining(true);
    try {
      await onAccept(invitation);
    } catch {
      setIsJoining(false);
      onError?.();
    }
  };

  return (
    <div className="bg-neutral-50 flex flex-col gap-6 items-center w-[400px] sm:w-[440px] px-6 sm:px-10 py-8 rounded-2xl">
      <Logo.Light.FirmableFull height={30} width={142} />

      <div className="flex flex-col gap-2 items-center text-center w-full">
        <OrgAvatar org={invitation.publicOrganizationData} />
        <p className="font-semibold text-base text-black">{orgName}</p>
      </div>

      <div className="w-full bg-slate-100 border border-slate-200 rounded-lg p-4">
        <p className="text-sm font-semibold text-slate-600 text-center">
          You&apos;ve been invited to join this company.
        </p>
      </div>

      <div className="flex flex-col gap-4 items-center w-full">
        <V2.Button
          variant="primary"
          size="lg"
          disabled={isJoining}
          onClick={handleJoin}
          className="!w-full !h-11 !bg-brand-1-600 hover:!bg-brand-1-700 !text-white !font-semibold !text-base !rounded-lg shadow-btn-bevel">
          {isJoining ? 'Joining...' : `Join ${orgName}`}
        </V2.Button>

        {onCreateCompany && <CreateCompanyFooter onClick={onCreateCompany} />}
      </div>
    </div>
  );
};
